import React from "react";

const Loading = ({ text = "Loading..." }) => {
  return (
    <div className="loading-wrap text-center">
      {/* <div className="loader"></div> */}
       <div className="shape-loading" aria-hidden="true">
            {Array.from({ length: 5 }).map((_, i) => (
                <span key={i} className={`shape shape-${i + 1}`}></span>
            ))}
        </div>
      <p>{text}</p>
    </div>
  );
};

export default Loading;